<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" icon="fa-code" />
    <!-- End Breadcrumb -->
    <!-- search_route="/home_page/intro/meta"
        search_title="Meta" -->

    <!-- Start Statistics Card-->
    <!-- <div class="row mb-5">
      <div class="wrraper">
        <stats-card :number="rows.length"></stats-card>
      </div>
    </div> -->
    <!-- End Statistics Card-->

    <!-- Start Main Section -->
    <main>
      <div class="home_slider">
        <div class="text_section">
          <div
            class="tw-text-3xl md:tw-text-5xl xl:tw-text-6xl tw-capitalize tw-font-montserrat tw-text-center md:tw-leading-[3.5rem] tw-font-bold tw-max-w-[630px] xl:tw-max-w-[800px] tw-max-h-fit tw-mx-auto tw-text-black"
            v-html="intro.title"
          ></div>
          <!-- <h1 :class="{'main_header_text_ar':$i18n.locale == 'ar'}" v-html="intro.title"></h1> -->
          <p
            class="tw-max-w-[500px] tw-mx-auto tw-text-[#737195] tw-text-center tw-mt-5"
          >
            {{ intro.desc }}
          </p>
        </div>
        <div class="row">
          <text-card
            class="col-lg-4 col-md-6 col-sm-12"
            v-for="(card, index) in intro.features.slice(0, 3)"
            :key="card.id"
            :cardData="card"
            :status="index"
            :backgroundColor="card.background"
          />
        </div>
      </div>
    </main>
    <!-- End Main Section -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    TextCard: () => import("@/components/UI/cards/TextCard.vue"),
  },
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.intro.title"),
          disabled: false,
          href: "/home_page/intro",
        },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },

      // ========== Body Section
      calories: "",

      // ========== Your Data
      intro: {},

      // ========== elected Data
      selected: [],
      singleSelect: false,

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
      },

      // ========== Loding
      lodaing: false,
    };
  },

  watch: {
    [`paginations.current_page`]() {
      this.setRows();
    },
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
  },

  methods: {
    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },
    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/settings/about/add" });
    },
    showItem(item) {
      this.$router.push({ path: "/settings/about/show/" + item.id });
    },
    editItem(item) {
      this.$router.push({ path: "/settings/about/edit/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.axios({
        method: "DELETE",
        url: `about/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    deleteSelected() {
      this.dialogDelete_selected = true;
    },
    deleteSelectedConfirm() {
      this.axios({
        method: "POST",
        url: `coupon/deleteAll`,
        data: { ids: this.selected.map((item) => item.id) },
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return !this.selected.filter((obj) => obj.id == item.id).length > 0;
          });
          this.dialogDelete_selected = false;
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete_selected = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows() {
      this.lodaing = true;
      this.axios({
        method: "GET",
        url: "home/intro",
      })
        .then((res) => {
          this.intro = res.data.data;
          this.lodaing = false;
        })
        .catch(() => {
          this.lodaing = false;
          this.$router.push({ path: "/home_page/intro/add" });
        });
    },
  },

  // ======= hooks
  mounted() {
    // Set Rows
    this.setRows();
  },
};
</script>
<style lang="scss">
.home_slider {
  background: url("../../../../assets/images/homePage/backgroundBall.png");
  background-clip: border-box;
  background-repeat: no-repeat;
  background-position: top right;
  background-size: 48%;
  margin: auto;
  text-align: center;
  width: 100%;
  .text_section {
    // padding-block-start: 100px;
    margin: auto;
    // margin-block-end: 100px;
    min-height: 700px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    p {
      font-size: 17px;
      color: #2a398c;
      // font-family:$regular_font;
      max-width: 600px;
      width: 95%;
      text-align: center;
      margin-inline: auto;
      margin-bottom: 30px;
    }
    h1 {
      color: #141324;
      font-size: 98px;
      margin-bottom: 30px;
      font-weight: 800;
    }
    h1 .name {
      color: #2a398c;
      // font-family:$bold_font ;
      font-weight: 800;
      font-size: 98px;
      margin-bottom: 30px;
    }
  }
}
</style>
